/**
 * Auto-generated lucide icon component.
 *
 * @see https://lucide.dev/icons/x
 */
import { default as DefaultIcon } from '~icons/lucide/x';
import { Icon, type IconProps } from 'src/components/media-and-icons/icon';

export const XIcon = (props: IconProps) => (
  <Icon icon={DefaultIcon} {...props} />
);
